// @flow
import * as React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Navbar from "../../Layouts/Navbar";
import Header from "../../Layouts/Header";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {FaAngleLeft} from "react-icons/fa";
import FestivalBadge from "../../Assets/Images/festival.png"

export default function VendorsList(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vendors, setVendors] = React.useState([]);

    React.useEffect(() => {
        window.localStorage.removeItem("fromSearch");
        const params = {
            count : 30,
            list: 1,
            orderBy: 'id',
            orderType: 'asc',
            product_group_id: id
        }

        API.getVendors(params)
            .then((response) => {
                setVendors(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, [id]);
    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='لیست تامین کنندگان' hasBack={true} />

            {/* Servitor */}
            <section className="container-fluid  mt-3 py-5 rtl px-0 mb-5  ">

                <div className="row mx-3">
                    {
                        vendors.map (vendor => {
                            return (
                                <div className="col-12 p-3 py-1" key={vendor.id}
                                     onClick={
                                         () => {
                                             if (vendor.same_area ){
                                                 navigate(`/vendor/${vendor.id}`);
                                             }
                                             else {
                                                toast.warning('عدم فروش محصول در محدوده شما')
                                             }

                                         }
                                     }
                                >
                                    <div className="vendor-container row p-2 ">
                                        <div className="col-3 vendor-image  ">
                                            {
                                                vendor.is_selected > 0 &&
                                                <img alt='festival' src={FestivalBadge}
                                                style={{height: '20px'}}
                                                />


                                            }
                                            <img src={vendor.image} alt={vendor.title}
                                                 style={vendor.is_selected > 10
                                                     ? { border: '3px solid gold' ,  borderRadius: "100%" }
                                                     : undefined}

                                            />

                                        </div>
                                        <div className="col-9 ">
                                        <div className="title py-2 pe-2">

                                                {vendor.title}
                                            <span className='float-start'>
                                                <FaAngleLeft />
                                            </span>


                                        </div>
                                            <div className="description pe-2 ">
                                                {
                                                    vendor.same_area ?

                                                        <span>
                                                             {vendor.brief.substring(0,45)} ...
                                                        </span>
                                                        :
                                                        <strong className='text-danger'>
                                                            عدم فروش محصول در محدوده شما
                                                        </strong>
                                                }


                                            </div>

                                        </div>

                                    </div>
                                </div>
                            )} )

                    }
                </div>
            </section>

            <Navbar />
        </React.Fragment>
    );
};
